import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'portal.views.forgotPassword.label.title',
    defaultMessage: 'Forgot your password',
    description: 'Forgot password page heading',
  },
  instructions: {
    id: 'portal.views.forgotPassword.label.instructions',
    defaultMessage: 'Enter your email address and we will send you instructions to reset your password.',
    description: 'Instructions text',
  },
  fieldEmail: {
    id: 'portal.views.forgotPassword.field.emailOrUsername.placeholder',
    defaultMessage: 'Email address',
    description: 'Email placeholder',
  },
  haveAccount: {
    id: 'portal.views.forgotPassword.text.haveAccount',
    defaultMessage: 'Already have an account?',
    description: 'Already have an account',
  },
  continue: {
    id: 'portal.views.forgotPassword.button.continue',
    defaultMessage: 'Continue',
    description: 'Continue button',
  },
  logIn: {
    id: 'portal.views.forgotPassword.link.logIn',
    defaultMessage: 'Log In',
    description: 'Link to login page',
  },
  enterEmail: {
    id: 'portal.views.forgotPassword.validation.enterEmail',
    defaultMessage: 'Enter your email address',
    description: 'Validation: empty email',
  },
  invalidEmail: {
    id: 'portal.views.forgotPassword.validation.invalidEmail',
    defaultMessage: 'Enter a valid email address',
    description: 'Validation: invalid email format',
  },
  tooManyAttempts: {
    id: 'portal.views.forgotPassword.tooManyAttempts',
    defaultMessage: 'Too many requests. Please try again later.',
    description: 'Error for too many reset attempts',
  },
  internalServerError: {
    id: 'portal.views.forgotPassword.internalServerError',
    defaultMessage: 'An error occurred. Please try again later.',
    description: 'Generic internal server error',
  },
  errorTitle: {
    id: 'portal.views.forgotPassword.errorTitle',
    defaultMessage: 'Error',
    description: 'Error notification title',
  },
});

export default messages;
